export const BREAKPOINT_CHANGED = 'BREAKPOINT_CHANGED';
export const BREAKPOINT_UNCHANGED_AT_HYDRATION = 'BREAKPOINT_UNCHANGED_AT_HYDRATION';

export function breakpointChanged(breakpoint) {
  return {
    type: BREAKPOINT_CHANGED,
    payload: {
      breakpoint,
    },
  };
}

export function breakpointUnchangedAtHydration() {
  return {
    type: BREAKPOINT_UNCHANGED_AT_HYDRATION,
  };
}
